
















import Vue from 'vue'
import Button from '@/components/shared/atoms/Button/Button'
import { oneOf } from '@/utils/helper'

interface IData {
  processTimeout: NodeJS.Timeout | null
}

export default Vue.extend({
  components: {
    Button
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    canSubmit: {
      type: Boolean,
      default: true
    },
    submitText: {
      type: String,
      default: '送信'
    },
    withSpacing: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'primary',
      validator: oneOf(['primary', 'secondary'])
    },
    throttle: {
      type: Number,
      default: 2000
    }
  },
  data(): IData {
    return {
      processTimeout: null
    }
  },
  destroyed() {
    if (this.processTimeout) clearTimeout(this.processTimeout)
  },
  methods: {
    handleSubmit() {
      if (!this.processTimeout) {
        this.$emit('submit')
        const vm = this
        vm.processTimeout = setTimeout(() => {
          vm.processTimeout = null
        }, this.throttle)
      }
    }
  }
})
